import {
  EChatbotColorPalette,
  EChatbotTheme,
  TChatbotSettingsLayout,
} from '~/features/settings/models'

export const defaultChatBotLayout: TChatbotSettingsLayout = {
  selection: {
    theme: EChatbotTheme.simple,
    custom: {
      [EChatbotTheme.simple]: false,
      [EChatbotTheme.linkView]: false,
    },
    [EChatbotTheme.linkView]: EChatbotColorPalette.teal,
    [EChatbotTheme.simple]: '#010e1c',
  },
  options: {
    [EChatbotTheme.linkView]: {
      [EChatbotColorPalette.teal]: {
        mainBackgroundColor: '#03424c',
        buttonColor: '#08A4BD',
        buttonTextColor: '#FFFFFF',
        accentColor: '#03424c',
        secondaryTextColor: '#03424c',
      },
      [EChatbotColorPalette.dark]: {
        mainBackgroundColor: '#010e1c',
        buttonColor: '#344559',
        buttonTextColor: '#FFFFFF',
        accentColor: '#010e1c',
        secondaryTextColor: '#010e1c',
      },
      [EChatbotColorPalette.purple]: {
        mainBackgroundColor: '#504685',
        buttonColor: '#b2abd3',
        buttonTextColor: '#FFFFFF',
        accentColor: '#504685',
        secondaryTextColor: '#504685',
      },
      [EChatbotColorPalette.neutral]: {
        mainBackgroundColor: '#bf5e62',
        buttonColor: '#f29195',
        buttonTextColor: '#FFFFFF',
        accentColor: '#bf5e62',
        secondaryTextColor: '#bf5e62',
      },
    },
    [EChatbotTheme.simple]: [
      '#010e1c',
      '#EF767A',
      '#6457A6',
      '#08A4BD',
      '#cca752',
    ],
  },
}

export const getDefaultWaveIconUrl = () =>
  `${window.location.origin}/images/chatbot-images/wave-icon.svg`

export default defaultChatBotLayout
